import { render, staticRenderFns } from "./todolist.vue?vue&type=template&id=33a9d6d2&"
import script from "./todolist.vue?vue&type=script&lang=js&"
export * from "./todolist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports